// eslint-disable-next-line import/no-mutable-exports
// import { getCookie } from './cookie';
const aegisUtil = (() => {
  const empty = () => {};
  let aegis = {
    info: (...arg) => console.info(...arg),
    infoAll: (...arg) => console.info(...arg),
    error: (...arg) => console.error(...arg),
    report: empty,
    setConfig: empty,
    reportTime: empty,
    time: empty,
    timeEnd: empty,
    reportSpeedLog: empty,
  }; // 预防直出逻辑问题，以后看看有没更优雅写法

  // 因资源的问题，下掉aegis
  // if (typeof window !== 'undefined') {
  //   const Aegis = require('@tencent/aegis-web-sdk');
  //   let aegisId = 'lJLdzFyzqGnRgJdl1L'; // 正式的ID，aegis上报从TAM切换到RUM
  //   if (window.CONSTANTS && window.CONSTANTS.aegisId) {
  //     // 灰度取的不同id
  //     aegisId = window.CONSTANTS.aegisId;
  //   }
  //   aegis = new Aegis({
  //     id: aegisId, // 项目ID
  //     uin: getCookie('qb_guid') ?? 'no_guid', // 用户唯一 ID（可选）
  //     reportApiSpeed: true, // 接口测速
  //     reportAssetSpeed: true, // 静态资源测速
  //     beforeReport(log) {
  //       // 白名单日志过滤掉灯塔的一些上报方便查看
  //       if (log.level === '1' && log.msg && log.msg.indexOf('otheve.beacon.qq.com/analytics/upload?tp=js') !== -1) {
  //         return false;
  //       }
  //     },
  //     api: {
  //       retCodeHandler(rsp) {
  //         let data = rsp;
  //         let code = 0; // 默认code为0
  //         if (typeof data === 'string') {
  //           try {
  //             data = JSON.parse(data);
  //             code = data?.retCode ?? data?.code ?? data?.retcode ?? 0; // 因为正文没有统一的格式，所以没有retCode大部分retCode会统计不到, 默认为0
  //           } catch (ignore) {}
  //         }
  //         return {
  //           isErr: code !== 0,
  //           code,
  //         };
  //       },
  //     },
  //   });
  // }

  return aegis;
})();

export default aegisUtil;
